import { AssignmentReturn, Edit } from "@mui/icons-material";
import ContextMenuSelectionCount from "../../../../components/shared/ContextMenuSelectionCount";
import { toastMessage } from "../../../../constants/strings";
import type { ContextMenuAction } from "../../../../types/contextMenuAction";
import type { OSADShipments } from "../../../../types/operations/osad.type";
import type { ServiceCenter } from "../../../../types/serviceCenter.type";
import { toast } from "../../../../utils/snackbarHelper";
import { unifyShipmentContext } from "../../../../utils/unifyShipmentContext";
import type {
  OpenDialogParams,
  SummaryContext,
} from "../../shared/ActionsMenuContext";
import { UnassignMenuItem } from "../PlanningContextMenu/UnassignMenuItem";
import { formatOsadToPlannedRoute } from "../utils";

interface OsadContextMenuActionsProps {
  serviceCenter: ServiceCenter;
  date: number;
  osad: OSADShipments;
  shipmentContext: SummaryContext[];
  openDialog: (openDialogParams: OpenDialogParams) => void;
  clearSelection?: () => void;
  onEditReason?: () => void;
}

export const osadContextMenuActions = ({
  serviceCenter,
  date,
  osad,
  shipmentContext,
  openDialog,
  clearSelection,
  onEditReason,
}: OsadContextMenuActionsProps): ContextMenuAction[] => {
  const unifiedShipmentContext = unifyShipmentContext(shipmentContext);

  const osadToPlan = formatOsadToPlannedRoute({ osad, date, serviceCenter });

  const actions: ContextMenuAction[] = [
    {
      label: "Selection count",
      itemComponent: (
        <ContextMenuSelectionCount count={shipmentContext.length} />
      ),
    },
    {
      label: "Assign To",
      barLabel: "Assign To",
      icon: <AssignmentReturn />,
      disabled: shipmentContext.length <= 0,
      handleClick: () => {
        if (!shipmentContext.length) {
          toast(toastMessage.inbound.assign.noneSelected, {
            variant: "warning",
          });
        } else if (
          unifiedShipmentContext.map((s) => s.shipmentIds).flat().length === 0
        ) {
          toast(toastMessage.inbound.assign.noShipmentsToAssign, {
            variant: "warning",
          });
        } else {
          openDialog({
            name: "assign-to",
            shipmentContext: unifiedShipmentContext,
            clearSelection,
          });
        }
      },
    },
    {
      label: "Unassign",
      barLabel: "Unassign",
      itemComponent: (
        <UnassignMenuItem
          shipmentContext={shipmentContext}
          clearSelection={clearSelection}
          routesOrTraps={[osadToPlan]}
        />
      ),
      keepOpenAfterClick: false,
    },
    ...(onEditReason
      ? [
          {
            label: "Edit",
            icon: <Edit fontSize="small" />,
            handleClick: onEditReason,
          },
        ]
      : []),
  ];

  return actions;
};
